import { createContext, useContext } from 'react';

/**
 * Whether the console is talking to a merchant rather than to Sorting Company staff.
 *
 * A merchant's login sees the same pages in the shop's own words - MPOS's "shop" and
 * "counter", and "connect" where staff say "pair" - and without what only staff act on:
 * key ids, MPOS ids, time zones, webhook URLs. The owner asked on 2026-10-28 for no
 * technical terms on a customer's screens. Wording only: what a login may do is still
 * decided by the server.
 */
const PlainLanguage = createContext(false);

export const PlainLanguageProvider = PlainLanguage.Provider;

export function usePlainLanguage(): boolean {
  return useContext(PlainLanguage);
}
